import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {StaffPosition, StaffPositionSearchParams} from '@accounting/_common/models/staff-position.models';
import {CategoryListResponse, EntityCategoryTree} from '@common/components-standalone/reference-category-module/category.type';
import {CategoriesTreeState} from '@common/models/entity-state.models';

export const CheckState = createAction(
    '[StaffPositions] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: StaffPosition[] } }>()
);

export const CheckStateSuccess = createAction(
    '[StaffPositions] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: StaffPosition[] } }>()
);

export const LoadCategories = createAction(
    '[StaffPositions] Load Categories',
    props<{ forceUpdate: boolean }>()
);

export const LoadCategoriesSuccess = createAction(
    '[StaffPositions] Load Categories Success',
    props<{ payload: CategoryListResponse[] }>()
);

export const UpsertCategory = createAction(
    '[StaffPositions] Upsert Category',
    props<{ payload: CategoryListResponse }>()
);

export const DeleteCategory = createAction(
    '[StaffPositions] Delete Category',
    props<{ payload: EntityCategoryTree }>()
);

export const SetCategoriesState = createAction(
    '[StaffPositions] Set Categories State',
    props<{ payload: CategoriesTreeState }>()
);

export const LoadList = createAction(
    '[StaffPositions] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[StaffPositions] Load List Success',
    props<{ payload: { items: StaffPosition[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[StaffPositions] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[StaffPositions] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[StaffPositions] Set Filter',
    props<{ payload: StaffPositionSearchParams, selectedCategory?: EntityCategoryTree }>()
);

export const SetLoading = createAction(
    '[StaffPositions] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[StaffPositions] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[StaffPositions] Update Item Success',
    props<{ payload: StaffPosition }>()
);

export const DeleteItem = createAction(
    '[StaffPositions] Delete Item',
    props<{ payload: StaffPosition }>()
);

export const DeleteItemSuccess = createAction(
    '[StaffPositions] Delete Item Success',
    props<{ payload: StaffPosition }>()
);

export const DeleteItemFailure = createAction(
    '[StaffPositions] Delete Item Failure',
    props<{ payload: StaffPosition }>()
);

export const SetInitialState = createAction(
    '[StaffPositions] Set Initial State'
);

export const UpdateStaffPositionItem = createAction(
    '[StaffPositions] Update StaffPosition Item',
    props<{ payload: StaffPosition }>()
);
